<sp-toolbar-widget
    [name]="widget.name"
    [title]="getWidgetTitle() | translate"
    [disabled]="disabled"
    [disabledTooltip]="disabledTooltip | translate"
    (onClick)="onClick.emit($event); showPaidFeaturesModal()"
>
    <ng-template #labelTemplate>
        <span *ngIf="widget.params.isEducation" class="edu-label">{{ "edu_label" | translate }}</span>
        <span *ngIf="testimonialDisabled" class="badge badge-paid">&nbsp;</span>
        <sup *ngIf="!widget.permission.isReleased" class="color-danger font-weight-bold soon-label">
            {{ "soon" | translate }}
        </sup>
        <span *ngIf="!hasAccess" class="badge badge-paid" [class]="badgeTariffClass">&nbsp;</span>
    </ng-template>
</sp-toolbar-widget>
